import { Radio, Typography, type RadioProps } from '@mui/material'
import { FC } from 'react'
import styles from './RadioItem.module.scss'
import { Tooltip } from '../tooltip/Tooltip'
import { useBreakpoints } from '@obeta/data/lib/hooks'
import { InfoIcon } from '../icons'

type RadioItemLabelProps = {
  disabled?: boolean
  label: string
  tooltip?: boolean
}

const RadioItemLabel: FC<RadioItemLabelProps> = (props) => {
  const { disabled, label, tooltip } = props

  return (
    <Typography
      className={tooltip ? styles.tooltip : undefined}
      data-testid="item-label"
      noWrap
      color={disabled ? 'textDisabled' : 'secondary.main'}
      variant="bodyBold"
    >
      {label}
    </Typography>
  )
}

type RadioItemProps = {
  label?: string
  tooltip?: string
}

export const RadioItem: FC<RadioItemProps & RadioProps> = (props) => {
  const { disabled, label, tooltip } = props

  const { desktop } = useBreakpoints()

  return (
    <div className={styles.item}>
      <Radio className={styles.radio} {...props} />
      {!desktop && (
        <>
          {label && !tooltip && <RadioItemLabel disabled={disabled} label={label} />}
          {label && tooltip && (
            <Tooltip activateOnClick={!desktop} title={tooltip}>
              <span>
                <RadioItemLabel disabled={disabled} label={label} tooltip />
              </span>
            </Tooltip>
          )}
        </>
      )}
      {desktop && label && (
        <div className={styles.content}>
          <RadioItemLabel disabled={disabled} label={label} />
          {tooltip && (
            <Tooltip title={tooltip}>
              <InfoIcon className={styles.icon} />
            </Tooltip>
          )}
        </div>
      )}
    </div>
  )
}
